import dayjs from "dayjs";

import newYearBackground from "./images/new-year-bg.png";

// 新年裝飾結束日期
const NEW_YEAR_DECORATION_END_DATE = "2026-02-26";

/**
 * 判斷是否在新年裝飾期間內
 * @returns {boolean} 是否顯示新年裝飾
 */
export const isNewYearDateExpire = () => {
  return dayjs().isAfter(dayjs(NEW_YEAR_DECORATION_END_DATE));
};

/**
 * 取得背景圖路徑（新年期間使用特殊背景）
 * @param {string} originalBgPath - 原始背景圖路徑
 * @returns {string} 應該使用的背景圖路徑
 */
export const getBackgroundImage = (originalBgPath) => {
  // 在新年裝飾期間之前使用新年背景，之後自動回到原本背景
  return isNewYearDateExpire() ? originalBgPath : newYearBackground;
};
